export const object = {
  inputSelector: '.popup__input',
  submitButtonSelector: '.popup__button',
  inactiveButtonClass: 'popup__button_disabled',
  inputErrorClass: 'popup__input_type_error',
  errorClass: 'popup__error_visible'
};

export const editButton = document.querySelector('.profile__edit');
export const profileAddButton = document.querySelector('.profile__add-button');
export const profileAvatar = document.querySelector('.profile__avatar');
export const popupPlaceProfile = document.querySelector('.popup_place_profile');
export const popupPlaceCard = document.querySelector('.popup_place_card');
export const popupPlaceAvatar = document.querySelector('.popup_place_avatar');
export const popupFormPlaceCard = popupPlaceCard.querySelector('.popup__form');
export const popupName = document.querySelector('.popup__input_place_name');
export const popupActivity = document.querySelector('.popup__input_place_activity');